import { useMemo } from "react";
import { myCafeteriaRoutes } from "my-cafeteria/configs";
import { myDocumentsRoutes } from "my-documents/configs";
import { myHRRoutes } from "my-hr/configs/routes";
import { myLeaveRoutes } from "my-leave/configs/routes";
import { myNewsRoutes } from "my-news/configs/routes";
import { myTaxRoutes } from "my-tax/configs/routes";
import { myTimeRoutes } from "my-time/configs/routes";
import { myTimesheetRoutes } from "my-timesheet/configs/routes";
import { ocRoutes } from "oc/configs/routes";
import { RouteDef } from "oc/types";

/**
 * Aggregates all OC-related route definitions.
 */
export const useOcGenerateRoutes = (): RouteDef[] => {
  const routeDefs = useMemo<RouteDef[]>(
    () => [
      ...myHRRoutes,
      ...myLeaveRoutes,
      ...myCafeteriaRoutes,
      ...myTaxRoutes,
      ...myTimeRoutes,
      ...myDocumentsRoutes,
      ...myNewsRoutes,
      ...myTimesheetRoutes,
      ...ocRoutes,
    ],
    [],
  );

  return routeDefs;
};

export default useOcGenerateRoutes;
